// extracted by mini-css-extract-plugin
export var content = "EduCard-module--content--17da2";
export var icon = "EduCard-module--icon--f5545";
export var wrapper = "EduCard-module--wrapper--55e8f";